/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-unnamed-components */
/* eslint-disable no-unused-vars */

'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["useTrellisSmileys"];
import { isCanvasTheme, useTheme } from 'foundations-theming/utils';
import CsatButton from './internal/CsatButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TRELLIS_SMILEYS_NEUTRAL_COLOR, resolveRespondentCssColor } from 'feedback-schema/constants/respondentTypeColorTokens';
import * as RespondentTypes from 'feedback-schema/constants/respondentTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const path = 'M416 0Q303 0 206 57q-94 55-149 149Q0 303 0 416t57 210q55 94 149 150 97 56 210 56t210-56q94-56 149-150 57-97 57-210t-57-210q-55-94-149-149Q529 0 416 0zm145 290q18 0 32 10t21 26q4 11 4 22 0 24-17 41t-40 17q-12 0-23-4h1q-16-7-26-21.5T503 349q0-24 17-41t41-18zm-290 0q24 0 41 17t17 41-17 41-41 17q-13 0-24-4h1q-16-7-25.5-21.5T213 349q0-24 16.5-41t40.5-18h1zm-9 264h308q13 0 22.5 9.5T602 586t-9.5 22.5T570 618H262q-13 0-22.5-9.5T230 586t9.5-22.5T262 554z';
export default (_ref => {
  let {
      useTrellisSmileys = false
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const trellisTheme = useTheme();
  return isCanvasTheme(trellisTheme) ? /*#__PURE__*/_jsx(CsatButton, Object.assign({
    color: trellisTheme.color['do-not-use-chart-orange'],
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "feedback-shared.ratings.neutral"
    }),
    viewBox: "0 0 54 54"
  }, props, {
    children: /*#__PURE__*/_jsx("g", {
      id: "Setup---Choose-Survey---CSAT---Chat",
      transform: "translate(-958.000000, -762.000000)",
      fillRule: "nonzero",
      children: /*#__PURE__*/_jsx("g", {
        id: "chat-widget",
        transform: "translate(761.000000, 320.000000)",
        children: /*#__PURE__*/_jsxs("g", {
          id: "Neutral",
          transform: "translate(198.000000, 443.000000)",
          children: [/*#__PURE__*/_jsx("path", {
            d: "M26,0 C11.6405965,0 0,11.6405965 0,26 C0,40.3594035 11.6405965,52 26,52 C40.3594035,52 52,40.3594035 52,26 C51.9787869,11.6493924 40.3506076,0.0212130541 26,0 Z",
            id: "Path",
            stroke: "#33475C",
            strokeWidth: "2",
            fill: "#FDCABD"
          }), /*#__PURE__*/_jsx("path", {
            d: "M35.0518519,18.1422222 C36.5085151,18.1422222 37.821746,19.019695 38.3791869,20.3654764 C38.9366278,21.7112578 38.6285003,23.2603192 37.5984838,24.2903357 C36.5684673,25.3203522 35.019406,25.6284796 33.6736246,25.0710387 C32.3278432,24.5135978 31.4503704,23.200367 31.4503704,21.7437037 C31.4503704,19.7546604 33.0628086,18.1422222 35.0518519,18.1422222 L35.0518519,18.1422222 Z",
            id: "Path",
            fill: "#33475C"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.9481481,18.1422222 C18.4048114,18.1422222 19.7180423,19.019695 20.2754832,20.3654764 C20.8329241,21.7112578 20.5247966,23.2603192 19.4947801,24.2903357 C18.4647636,25.3203522 16.9157022,25.6284796 15.5699209,25.0710387 C14.2241395,24.5135978 13.3466667,23.200367 13.3466667,21.7437037 C13.3466667,19.7546604 14.9591048,18.1422222 16.9481481,18.1422222 Z",
            id: "Path",
            fill: "#33475C"
          }), /*#__PURE__*/_jsx("rect", {
            id: "Path",
            fill: "#33475C",
            x: "14.4444444",
            y: "34.4162963",
            width: "23.1111111",
            height: "3.85185185",
            rx: "1.92592593"
          })]
        })
      })
    })
  })) : /*#__PURE__*/_jsxs(CsatButton, Object.assign({
    color: resolveRespondentCssColor(RespondentTypes.PASSIVE, useTrellisSmileys, trellisTheme),
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "feedback-shared.ratings.neutral"
    }),
    viewBox: "0 0 80 80"
  }, props, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_604_1080)",
      children: [/*#__PURE__*/_jsx("rect", {
        width: "80",
        height: "80",
        rx: "40",
        fill: useTrellisSmileys ? TRELLIS_SMILEYS_NEUTRAL_COLOR : '#FCC6B1'
      }), /*#__PURE__*/_jsx("path", {
        d: "M52.8889 39.5556C55.997 39.5556 58.5185 37.0342 58.5185 33.926C58.5185 30.8179 55.997 28.2964 52.8889 28.2964C49.7807 28.2964 47.2593 30.8179 47.2593 33.926C47.2593 37.0342 49.7807 39.5556 52.8889 39.5556Z",
        fill: "#141414"
      }), /*#__PURE__*/_jsx("path", {
        d: "M32.7407 33.8668C32.7407 30.7586 30.2193 28.2371 27.1111 28.2371C24.003 28.2371 21.4815 30.7586 21.4815 33.8668C21.4815 36.9749 24.003 39.4964 27.1111 39.4964C30.2193 39.4964 32.7407 36.9749 32.7407 33.8668Z",
        fill: "#141414"
      }), /*#__PURE__*/_jsx("path", {
        d: "M57.7778 55.9112C57.7778 54.2756 56.4504 52.9482 54.8148 52.9482H25.1852C23.5496 52.9482 22.2222 54.2756 22.2222 55.9112C22.2222 57.5468 23.5496 58.8742 25.1852 58.8742H54.8148C56.4504 58.8742 57.7778 57.5468 57.7778 55.9112Z",
        fill: "#141414"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 40C0 62.0919 17.9081 80 40 80H40.003C62.0859 79.9822 79.9822 62.0859 80 40C80 17.9081 62.0919 0 40 0C17.9081 0 0 17.9081 0 40ZM5.71852 40C5.71852 21.0667 21.0667 5.71852 40 5.71852H40.003C58.9274 5.7363 74.2637 21.0726 74.2815 40C74.2815 58.9333 58.9333 74.2815 40 74.2815C21.0667 74.2815 5.71852 58.9333 5.71852 40Z",
        fill: "#141414"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_604_1080",
        children: /*#__PURE__*/_jsx("rect", {
          width: "80",
          height: "80",
          rx: "40",
          fill: "white"
        })
      })
    })]
  }));
});